<mat-card class="sanction-card" *ngIf="stageFields == 'sanction'">
  <mat-card-header>
    <mat-card-title>Sanction Stage</mat-card-title>
  </mat-card-header>

  <mat-card-content>
    <div class="sanction-grid">
      <div *ngFor="let field of sanctionFields" class="sanction-item">
        <mat-icon
          [color]="sanctionForm.get(field.key)?.value ? 'primary' : 'warn'"
          class="status-icon"
        >
          {{ sanctionForm.get(field.key)?.value ? "check_circle" : "cancel" }}
        </mat-icon>

        <span class="field-label">{{ field.label }}</span>

        <div class="action-buttons">
          <a
            *ngIf="sanctionForm.get(field.key)?.value"
            [href]="getDownloadLink(sanctionForm.get(field.key)?.value)"
            target="_blank"
            mat-icon-button
            matTooltip="View PDF"
          >
            <mat-icon color="accent">visibility</mat-icon>
          </a>

          <input
            type="file"
            accept="application/pdf"
            hidden
            #fileInput
            (change)="onFileUpload($event, field.key)"
          />
          <button
            mat-icon-button
            (click)="fileInput.click()"
            matTooltip="Upload PDF"
          >
            <mat-icon color="primary">upload_file</mat-icon>
          </button>
        </div>
      </div>
    </div>
  </mat-card-content>
</mat-card>
<mat-card class="sanction-card" *ngIf="stageFields == 'feasibility'">
  <mat-card-header>
    <mat-card-title>Feasibility Stage</mat-card-title>
  </mat-card-header>

  <mat-card-content>
    <div class="sanction-grid">
      <div *ngFor="let field of feasibilityFields" class="sanction-item">
        <mat-icon
          [color]="sanctionForm.get(field.key)?.value ? 'primary' : 'warn'"
          class="status-icon"
        >
          {{ sanctionForm.get(field.key)?.value ? "check_circle" : "cancel" }}
        </mat-icon>

        <span class="field-label">{{ field.label }}</span>

        <div class="action-buttons">
          <a
            *ngIf="sanctionForm.get(field.key)?.value"
            [href]="getDownloadLink(sanctionForm.get(field.key)?.value)"
            target="_blank"
            mat-icon-button
            matTooltip="View PDF"
          >
            <mat-icon color="accent">visibility</mat-icon>
          </a>

          <input
            type="file"
            accept="application/pdf"
            hidden
            #fileInput
            (change)="onFileUpload($event, field.key)"
          />
          <button
            mat-icon-button
            (click)="fileInput.click()"
            matTooltip="Upload PDF"
          >
            <mat-icon color="primary">upload_file</mat-icon>
          </button>
        </div>
      </div>
    </div>
  </mat-card-content>
</mat-card>
<mat-card class="sanction-card" *ngIf="stageFields == 'completion'">
  <mat-card-header>
    <mat-card-title>Completion Stage</mat-card-title>
  </mat-card-header>

  <mat-card-content>
    <div class="sanction-grid">
      <div *ngFor="let field of completionFields" class="sanction-item">
        <mat-icon
          [color]="sanctionForm.get(field.key)?.value ? 'primary' : 'warn'"
          class="status-icon"
        >
          {{ sanctionForm.get(field.key)?.value ? "check_circle" : "cancel" }}
        </mat-icon>

        <span class="field-label">{{ field.label }}</span>

        <div class="action-buttons">
          <a
            *ngIf="sanctionForm.get(field.key)?.value"
            [href]="getDownloadLink(sanctionForm.get(field.key)?.value)"
            target="_blank"
            mat-icon-button
            matTooltip="View PDF"
          >
            <mat-icon color="accent">visibility</mat-icon>
          </a>

          <input
            type="file"
            accept="application/pdf"
            hidden
            #fileInput
            (change)="onFileUpload($event, field.key)"
          />
          <button
            mat-icon-button
            (click)="fileInput.click()"
            matTooltip="Upload PDF"
          >
            <mat-icon color="primary">upload_file</mat-icon>
          </button>
        </div>
      </div>
    </div>
  </mat-card-content>
</mat-card>
<mat-card class="sanction-card" *ngIf="domainS == 'Educational'">
   <mat-card-header>
    <mat-card-title>Educational Domain</mat-card-title>
  </mat-card-header>
  <mat-card-content>
    <div class="sanction-grid">
      <div *ngFor="let field of EducationalFields" class="sanction-item">
        <mat-icon
          [color]="sanctionForm.get(field.key)?.value ? 'primary' : 'warn'"
          class="status-icon"
        >
          {{ sanctionForm.get(field.key)?.value ? "check_circle" : "cancel" }}
        </mat-icon>

        <span class="field-label">{{ field.label }}</span>

        <div class="action-buttons">
          <a
            *ngIf="sanctionForm.get(field.key)?.value"
            [href]="getDownloadLink(sanctionForm.get(field.key)?.value)"
            target="_blank"
            mat-icon-button
            matTooltip="View PDF"
          >
            <mat-icon color="accent">visibility</mat-icon>
          </a>

          <input
            type="file"
            accept="application/pdf"
            hidden
            #fileInput
            (change)="onFileUpload($event, field.key)"
          />
          <button
            mat-icon-button
            (click)="fileInput.click()"
            matTooltip="Upload PDF"
          >
            <mat-icon color="primary">upload_file</mat-icon>
          </button>
        </div>
      </div>
    </div>
  </mat-card-content>
</mat-card>
<mat-card class="sanction-card" *ngIf="domainS == 'Commercial'">
   <mat-card-header>
    <mat-card-title>Commercial Domain</mat-card-title>
  </mat-card-header>
  <mat-card-content>
    <div class="sanction-grid">
      <div *ngFor="let field of CommercialFields" class="sanction-item">
        <mat-icon
          [color]="sanctionForm.get(field.key)?.value ? 'primary' : 'warn'"
          class="status-icon"
        >
          {{ sanctionForm.get(field.key)?.value ? "check_circle" : "cancel" }}
        </mat-icon>

        <span class="field-label">{{ field.label }}</span>

        <div class="action-buttons">
          <a
            *ngIf="sanctionForm.get(field.key)?.value"
            [href]="getDownloadLink(sanctionForm.get(field.key)?.value)"
            target="_blank"
            mat-icon-button
            matTooltip="View PDF"
          >
            <mat-icon color="accent">visibility</mat-icon>
          </a>

          <input
            type="file"
            accept="application/pdf"
            hidden
            #fileInput
            (change)="onFileUpload($event, field.key)"
          />
          <button
            mat-icon-button
            (click)="fileInput.click()"
            matTooltip="Upload PDF"
          >
            <mat-icon color="primary">upload_file</mat-icon>
          </button>
        </div>
      </div>
    </div>
  </mat-card-content>
</mat-card>
